import FullWidthLinkPic from '../../containers/pc-day/fragment/FullWidthLinkPic.jsx';
import DropDownWithCategory from '../../components/panel/DropDownWithCategory.jsx';
import DropDownWithCategoryDF from '../../components/panel/DropDownWithCategory-df.jsx';
import DropDownTextList from '../../components/panel/DropDownTextList.jsx';
import {LOTTERY_MENUS} from './lotteryMenus';
import { DOMAIN } from '../../constants/config'

/**
 * 用户菜单
 * @type {Array}
 * auth: 可见菜单用户类型
 */

// 恒耀众合
const USER_MENUS_HY = [
    {
        cnName: '首页',
        enName: 'Home',
        auth: [0,1,2],
        flag: '',
        className: '',
        hrefClassName: '',
        emClassName: '',
        iClassName:'i_icon-home',
        gamePageClassName:'',
        url: '#/',
        related: null,
        menuFlag:"home"
    },
    {
        cnName: '彩票',
        enName: 'Lottery',
        auth: [0,1,2],
        flag: '',
        className: '',
        hrefClassName: 'pannel-ddwc',
        emClassName: '',
        iClassName:'i_icon-cpyx',
        gamePageClassName:'cpyx re',
        url: '',
        related: <DropDownWithCategory lotterMenus={LOTTERY_MENUS} />,
        relatedGame: <DropDownWithCategory lotterMenus={LOTTERY_MENUS} />,
        menuFlag:"lottery"
    },
    {
        cnName: '真人',
        enName: 'Live',
        auth: [0,1,2],
        flag: '',
        className: 'pannel-fwlp',
        hrefClassName: '',
        emClassName: 'i_icon-new',
        iClassName:'i_icon-xcyl',
        gamePageClassName:'xcyl re',
        url: '#/casino',
        related: <FullWidthLinkPic className='nav-zr'
                                   displaySet={[
                                       {
                                           title:'PT真人娱乐',
                                           logo: 'lg_PTZR',
                                           url: '#/game/pt/casino',
                                           platfrom:'PT'
                                       },
                                       {
                                           title:'AG真人娱乐',
                                           logo: 'lg_AGZR',
                                           url: '#/game/ag/casino',
                                           platfrom:'AG'
                                       },
                                       {
                                           title:'BBIN真人娱乐',
                                           logo: 'lg_BBINZR',
                                           url: '#/game/bbin/casino',
                                           platfrom:'BBIN'
                                       }

                                   ]}
        />,
        menuFlag:"casino"
    },
    {
        cnName: '电游',
        enName: 'Games',
        auth: [0,1,2],
        flag: '',
        className: 'pannel-fwlp pannel-dzyx',
        hrefClassName: '',
        emClassName: 'i_icon-hot',
        iClassName:'i_icon-dzyx',
        gamePageClassName:'xcyl re',
        url: '#/slot',
        related: <FullWidthLinkPic className='nav-dz'
                                   displaySet={[
                                       {
                                           title:'PT电子游戏',
                                           logo: 'lg_PTDZ',
                                           url: '#/game/pt/slot',
                                           platfrom:'PT'
                                       },
                                       {
                                           title:'AG电子游戏',
                                           logo: 'lg_AGDZ',
                                           url: '#/game/ag/slot',
                                           platfrom:'AG'
                                       },
                                       {
                                           title:'BBIN电子游戏',
                                           logo: 'lg_BBINDZ',
                                           url: '#/game/bbin/slot',
                                           platfrom:'BBIN'
                                       }

                                   ]}
        />,
        menuFlag:"slot"
    },
    {
		cnName: '棋牌',
		enName: 'Chess',
		auth: [0,1,2],
		flag: '',
		className: 'pannel-fwlp pannel-qpyx',
		hrefClassName: '',
		emClassName: '',
		iClassName:'i_icon-qpyx',
		gamePageClassName:'xcyl re',
		url: '#/chess',
		related: <FullWidthLinkPic className='nav-qp'
					displaySet={[
            {
							title:'云游棋牌',
							logo: 'lg_YYCHESS',
							url: '/yygame/play',
							platfrom:'YY'
						},
            {
							title:'KGAME',
							logo: 'lg_KGAMECHESS',
							url: '/Kgame/play',
							platfrom:'KGAME'
						},
						{
							title:'瓦力棋牌',
							logo: 'lg_WALICHESS',
							url: '/waligame/play',
							platfrom:'WALI'
						}
					]}
				 />,
		menuFlag:"chess"
	},
    {
        cnName: '体育',
        enName: 'Sports',
        auth: [0,1,2],
        flag: '',
        className: '',
        hrefClassName: '',
        emClassName: 'i_icon-new',
        iClassName:'i_icon-tyjj',
        gamePageClassName:'xcyl re',
        url: '#/sports',
        related: null,
        menuFlag:"sports"
    },
    {
        cnName: '管理中心',
        enName: 'Team',
        auth: [0,1,2],
        flag: '',
        className: '',
        hrefClassName: '',
        emClassName: '',
        iClassName:'i_icon-group',
        gamePageClassName:'',
        url: '#/report/team/management/index',
        related: null,
        menuFlag:"report"
    },
    {
        cnName: '优惠活动',
        enName: 'Discount',
        auth: [0,1,2],
        flag: '',
        className: '',
        hrefClassName: '',
        emClassName: '',
        iClassName:'i_icon-activities',
        gamePageClassName:'',
        url: '#/activity/list',
        related: null,
        menuFlag:"activity"
    }
]

// 达福
const USER_MENUS_DF = [
  //   {
  //     cnName: '首页',
  //     enName: 'Home',
  //     auth: [0,1,2],
  //     flag: '',
  //     className: '',
  //     hrefClassName: '',
  //     emClassName: '',
  //     iClassName:'i_icon-home',
  //     gamePageClassName:'',
  //     url: '#/',
  //     related: null,
  //     menuFlag:"home"
  //   },
  {
    cnName: "sport",
    enName: "Sports",
    auth: [0, 1, 2],
    flag: "",
    className: "",
    hrefClassName: "pannel-ddwc",
    emClassName: "",
    iClassName: "i_icon-cpyx",
    gamePageClassName: "cpyx re",
    url: "#/sports",
    related: null,
    menuFlag: "sports",
  },
  {
    cnName: "administration center",
    enName: "Team",
    auth: [0, 1, 2],
    flag: "",
    className: "",
    hrefClassName: "",
    emClassName: "",
    iClassName: "i_icon-group",
    gamePageClassName: "",
    // url: '#/report/team/management/index',
    url: "#/report/personal/management/index",
    related: null,
    menuFlag: "report",
  },
];

var MENUS;
switch(window.vers){
  case 'df':  // 达福
    MENUS = USER_MENUS_DF;
    break;
  default:
    MENUS = USER_MENUS_HY;
}

export const USER_MENUS = MENUS;